"use client"
import { useEffect } from "react"
import CommonTextArea from "@/components/common/CommonTextArea"
import { contactInputs } from "@/utils"
import { useFormState, useFormStatus } from "react-dom"
import { toast } from "sonner"
import { contact } from "@/client/formClientActions"
import CustomButton from "@/components/common/CustomButton"

/**
 * @function ContactForm
 * This component renders a contact form that allows users to send messages.
 * It uses React's server actions (via `useFormState`) to handle form submission.
 * Email validation, error handling, and success/warning/error feedback are managed via toast notifications.
 */
const ContactForm = () => {
  const [data, formAction] = useFormState(contact, { status: false, message: "" })

  useEffect(() => {
    if (data.status) {
      const { status, message } = data
      switch (status) {
        case 200:
          toast.success(message)
          break
        case 401:
          toast.warning(message)
          break
        default:
          toast.error(message)
          break
      }
    }
  }, [data])

  return (
    <form action={formAction} className="space-y-6 flex flex-col justify-around">
      <div className="flex flex-col xl:flex-row gap-4 md:gap-6">
        {
          contactInputs.map(({ name, title, placeHolder, type }) => <label key={name} className='w-full xl:w-1/2 flex flex-col justify-center relative'>
            <div className='text-xs 2xl:text-sm font-semibold flex justify-between w-full'>{title}</div>
            <input
              name={name}
              required
              placeholder={placeHolder}
              type={type}
              className='w-full h-12 text-xs px-2 xl:text-sm rounded border border-gray-300 focus-within:border-gray-300 focus:border-gray-300'
            />
          </label>
          )
        }
      </div>
      <div className="w-full">
        <CommonTextArea
          title="Mensaje"
          name="message"
          width="w-full"
          type="text"
          placeHolder="Escriba aquí su mensaje..."
          minlength="10"
          maxlength="500"
          required
        />
      </div>
      <div className="pt-2">
        <ContactButton />
      </div>
    </form>
  )
}

/**
 * @function ContactButton
 * A reusable button component that reflects the form submission status using `useFormStatus`.
 * Shows "Enviando..." while waiting for a response, otherwise shows "Enviar mensaje".
 */
function ContactButton() {
  const { pending } = useFormStatus()

  return (
    <CustomButton
      type="submit"
      title={pending ? "Enviando..." : "Enviar mensaje"}
      colorType="primary"
      className="w-full md:w-auto"
    />
  )
}

export default ContactForm

